// src/pages/NotFound/NotFound.jsx
import React, {useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {Modal} from '@redq/reuse-modal';
import {
	NotFoundWrapper,
	NotFoundContainer,
	ContentWrapper,
	ErrorCode,
	ErrorTitle,
	ErrorDescription,
	ButtonGroup,
	PrimaryButton,
	SecondaryButton,
	IllustrationWrapper,
	AnimatedCircle,
	FloatingElement,
	BackgroundPattern,
} from './NotFound.style';
import t from "../../i18n/translate";

/**
 * NotFound Component - Modern 404 Page
 * Beautiful, animated error page with helpful navigation
 */
const NotFound = () => {
	useEffect(() => {
		setTimeout(() => {
			window.scrollTo({top: 0});
		}, 250)
	}, [])
	const history = useHistory();
	const windowLocation = history.location.pathname
	return (
		<Modal>
			<NotFoundWrapper>
				<BackgroundPattern/>

				<NotFoundContainer>
					{/* Animated Illustration */}
					<IllustrationWrapper>
						<AnimatedCircle delay={0}/>
						<AnimatedCircle delay={0.2}/>
						<AnimatedCircle delay={0.4}/>

						<ErrorCode>{t("errorCode")}</ErrorCode>

						<FloatingElement delay={0}>🔍</FloatingElement>
						<FloatingElement delay={0.5}>📦</FloatingElement>
						<FloatingElement delay={1}>🏠</FloatingElement>
					</IllustrationWrapper>

					{/* Content */}
					<ContentWrapper>
						<ErrorTitle>{t("errorTitle")}</ErrorTitle>

						<ErrorDescription>
							{t("errorDescription")}
						</ErrorDescription>

						{/* Action Buttons */}
						<ButtonGroup>
							<Link to={"/"} style={{textDecoration: 'none'}}>
								<PrimaryButton>
									<span className="icon">🏠</span>
									{t("backToHome")}
								</PrimaryButton>
							</Link>

							<Link to={windowLocation} style={{textDecoration: 'none'}}>
								<SecondaryButton onClick={windowLocation}>
									<span className="icon">🛍️</span>
									{t("browseProducts")}
								</SecondaryButton>
							</Link>
						</ButtonGroup>

						{/* Help Text */}
						<p style={{marginTop: '30px', fontSize: '14px', color: '#666'}}>
							{t("helpCenter")}?
							<Link to="/contact" style={{color: '#9cc54b', fontWeight: 600}}>                {t("contactSupport")}
							</Link>
						</p>
					</ContentWrapper>
				</NotFoundContainer>
			</NotFoundWrapper>
		</Modal>
	);
};

export default NotFound;